import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options.jsx';
import uniqBy from 'lodash/uniqBy';
import { getAssetCategories } from 'utils/helper/assetType';
import { ASSET_STATUS } from './helper';

const getAssetType = (category, assetType) => {
  return assetType.reduce((current, typeData) => {
    if (typeData.category === category) {
      return uniqBy(
        current.concat({
          id: typeData.id,
          name: typeData.name,
        }),
        'id',
      );
    } else {
      return current;
    }
  }, []);
};

export const filters = ({
  category,
  assetType,
  allowableCategories,
  userAssignedDepartments = [],
}) => {
  const departmentFilterField = departmentFilter(userAssignedDepartments);

  return {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
      {
        label: 'Category',
        field: 'category',
        type: 'select',
        options: getAssetCategories(allowableCategories),
      },
      {
        label: 'Type',
        field: 'type',
        type: 'select',
        options: getAssetType(category, assetType),
      },
      {
        label: 'Status',
        field: 'status',
        type: 'select',
        multiple: true,
        options: [
          ASSET_STATUS.AVAILABLE,
          ASSET_STATUS.DEPLOYING,
          ASSET_STATUS.IN_USE,
          ASSET_STATUS.RETURNING,
          ASSET_STATUS.UNAVAILABLE,
          ASSET_STATUS.UNREGISTERED,
        ],
      },
    ],
    AdvancedFilters: [...departmentFilterField],
  };
};
